module.exports = __webpack_public_path__ + "img/screens_banner.7caa9b7b.png";